



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FileSearchService, SearchCondition, FileData } from '@/services/files/FileSearch';
import FileCard from "@/components/files/searches/FileCard.vue";
import FileSearchHeader from "@/components/files/searches/FileSearchHeader.vue";
import FileSearchPagination from "@/components/files/searches/FileSearchPagination.vue";
import { scrollTop } from "@/utils/FileUtils";
import Loading from "@/components/Loading.vue";
import Dialog from "@/components/Dialog.vue";
import { isAllow } from '@/utils/RoleUtils';
import { isActiveServie } from '@/utils/AccountSettingUtils';
import { getOrInitializeSortOrder, setSortOrder, createSortInput, SORT_ORDER_KEYS, DEFAULT_SORT_ORDER } from "@/utils/SortUtils";

@Component({
  components: {
    FileCard,
    FileSearchHeader,
    FileSearchPagination,
    Loading,
    Dialog,
  }
})
export default class FileSearchResult extends Vue {
  private mode = 'file';
  private select = false;
  private selectedFiles = [];
  
  private total = 0;
  private files: FileData[] = [];
  private limit = 36;
  private attributes;
  
  private page = 1;
  private length = 0;

  private fileSearchService = new FileSearchService();
  private condition: SearchCondition = {};
  
  private sortOrder = DEFAULT_SORT_ORDER;

  private loading = false;
  private resultDialog = false;
  private resultDialogMode = '';
  private resultDialogTitle = '';
  private resultDialogMessage = '';
  private nextToken: string[] | undefined = undefined;
  private isSearchLimit = false;

  private get from(): number {
    return ((this.page - 1 ) > 0 ? (this.page - 1 ) : 0) * this.limit;
  }

  private get to(): number {
    if(this.from + this.limit >= FileSearchService.SEARCH_LIMIT) {
      return FileSearchService.SEARCH_LIMIT - this.from;
    }
    return this.limit;
  }

  @Watch('$route')
  private async onChangeRoute(){
    this.loading = true;
    await this.search();
  }

  private async created(){
    this.$store.commit("setGroupDetailPage", 1);
    this.page = this.$store.getters.searchResultPage ? this.$store.getters.searchResultPage : 1;
    
    this.sortOrder = await getOrInitializeSortOrder(SORT_ORDER_KEYS.FILE_SEARCH_RESULT);
    
    const user = this.$store.getters.user;
    this.attributes = user?.attributes;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filter: any = {};
    if(isAllow("filing", "search", "COMPANY") && await isActiveServie("filing")){
      filter.ownedAccountId = this.attributes["custom:account_id"];
    }else if(isAllow("filing", "search", "DEPARTMENT") && await isActiveServie("filing")){
      filter.ownedDepartment = this.attributes["custom:department"];
    }else if(isAllow("filing", "search", "SELF") && await isActiveServie("filing")){
      filter.createdUserId = this.attributes.sub;
    }
  }

  private async search(){
    this.isSearchLimit = false;
    this.page = this.$store.getters.searchResultPage ? this.$store.getters.searchResultPage : 1;
    this.condition = this.$store.getters.searchCondition ? JSON.parse(JSON.stringify(this.$store.getters.searchCondition)) : {};
    this.condition.groupIds = undefined;
    this.$store.commit("setSearchCondition", this.condition);
    
    // ソート順を取得（created()の処理完了前にsearch()が呼ばれる可能性があるため）
    this.sortOrder = await getOrInitializeSortOrder(SORT_ORDER_KEYS.FILE_SEARCH_RESULT);

    // ソート条件を作成
    const sort = createSortInput(this.sortOrder);
    
    try{
      const result = await this.fileSearchService.searchFiles(this.condition, undefined, this.from, this.to, sort);
      this.loading = false;
      if(result && result.items){
        this.files = result.items || [];
        this.total = result.total || 0;
        this.length = result.length || 0;
        this.nextToken = result.nextToken || undefined;
      }
    }
    catch(error){
      this.files = [];
      this.total = 0;
      this.length = 0;
      this.loading = false;
      this.resultDialog = true;
      this.resultDialogMode = "error";
      this.resultDialogTitle = "検索失敗";
      this.resultDialogMessage = `検索に失敗しました。\n再度、検索をお試しください。`;
      this.nextToken = undefined;
    }finally{
      this.loading = false;
      this.isSearchLimit = this.total > FileSearchService.SEARCH_LIMIT && (this.from + this.limit >= FileSearchService.SEARCH_LIMIT) ? true : false;
    }
  }

  private async onReload(){
    this.loading = true;
    await this.search();
  }

  private onChangeSelectMode(value){
    this.select = value;
    this.selectedFiles = [];
  }

  private async onPageNumberChanged(value){
    this.page = value;
    this.$store.commit("setSearchResultPage", this.page);
    this.loading = true;

    if(this.$store.getters.from?.name === "FileEdit"){
      this.$store.commit("setFrom", "");
      this.$store.commit("setTo", "");
      setTimeout(() => {
        this.search();
      }, 3000);
    }else{
      scrollTop();
      await this.search();
    }
  }

  private onChangeResultDialogClosed(){
    this.resultDialog = false;
  }

  private async onChangeFileSearchHeaderResult(value){
    if(value){
      this.loading = true;
      setTimeout(() => {
        this.search();
      }, 3000);
    }
  }

  private async onChangeFileCardResult(value){
    if(value){
      this.loading = true;
      setTimeout(() => {
        this.search();
      }, 3000);
    }
  }

  private onChangeSort(sortOrder: string){
    this.sortOrder = sortOrder;
    setSortOrder(SORT_ORDER_KEYS.FILE_SEARCH_RESULT, sortOrder);
    this.page = 1;
    this.$store.commit("setSearchResultPage", 1);
    this.onReload();
  }
}
